import { Box, IconButton, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { QaqcPanelHeaderTitle } from './QaqcPanelHeaderTitle';
import { qaqcPanelHeaderBarBaseSx, qaqcPanelHeaderBarDefaultSx } from './styles';

type Props = {
  onClose: () => void;
  variant?: 'default' | 'closeOnly';
};

export const QaqcPanelHeader = ({ onClose, variant = 'default' }: Props) => {
  if (variant === 'closeOnly') {
    return (
      <Box sx={qaqcPanelHeaderBarBaseSx}>
        <Stack direction="row" alignItems="center" justifyContent="flex-end">
          <IconButton onClick={onClose} size="small" aria-label="Close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Box>
    );
  }

  return (
    <Box sx={qaqcPanelHeaderBarDefaultSx}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Stack direction="row" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
          <IconButton onClick={onClose} size="small">
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <QaqcPanelHeaderTitle />
        </Stack>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};
